export default {
  headerName: 'Name',
  headerClientId: 'Client ID',
  headerDateCreated: 'Date created',
  headerRetries: 'Retries',
  headerActions: 'Actions',
  chipAbandoned: 'abandoned',
  tooltipAbandonedRetries: 'Given up on after {count} retries. It will not be retried again; restart it once the cause is fixed.',
  // Keyed by the code reportSpawnFailure writes for an error that retrying cannot fix.
  abandonedReasons: {
    missing_boot_image: 'The boot image family this model asks for does not exist in this project, which no retry can fix. Restart it once the image family is created or the model config is corrected.'
  },
  tooltipRestart: 'Restart',
  tooltipDelete: 'Delete',
  dialogWarningTitle: 'Warning',
  dialogDeleteMessage: 'The simulation document has been deleted by the user. Do you want to delete the queue document?',
  dialogDeleting: 'Deleting:',
  dialogConfirmMessage: 'This action cannot be undone. Are you sure?',
  dialogCancel: 'Cancel',
  dialogDelete: 'Delete',
  snackTryingRestart: 'Trying to restart plan',
  snackPlanRestarted: 'Pending plan restarted',
  snackDeletingPlan: 'Deleting plan',
  snackPlanDeleted: 'Plan deleted'
}
